module.exports = __webpack_public_path__ + "static/media/home2.c2e837fe.webp";